<app-toolbar></app-toolbar>

<app-header title="Interview mit Nico Rosberg" [small]="true">
  <a app-go-back class="link big white button">Zurück</a>
</app-header>
<div class="cream">
  <div class="container">
    <div style="float: left; margin-right: 10px; margin-bottom: 10px">
      <img src="./assets/img/etc/nico_rosberg.jpg" alt="Nico Rosberg / Foto: © Tom Ziora" /><br />
      <small>Foto: © Tom Ziora</small>
    </div>

    <p><strong>Wie kamst Du vom Rennsport dazu, Investor in der Start-up-Szene zu werden?</strong></p>
    <p>
      Ich wollte auch in meinem neuen Leben etwas Sinnvolles tun. Bereits während meiner Karriere als Formel-1-Fahrer habe ich mich mit Philosophie und
      Psychologie beschäftigt und daraus viele wichtige Erkenntnisse für mich gezogen. So war mir immer klar, dass ich auch als Unternehmer etwas positives
      bewegen und zurückgeben möchte und dabei möglichst viele Menschen erreichen will. Im Bereich Nachhaltigkeit habe ich dann mein neues Steckenpferd
      gefunden. Gerade hier passiert ja unheimlich viel, insbesondere im Start-up-Bereich. Die großen Player können oft nicht so frei und innovativ sein, wie
      kreative Querdenker und das finde ich unheimlich spannend.
    </p>

    <p><strong>Warum investierst Du in Food-Start-ups?</strong></p>
    <p>
      Weil die Nahrungsmittel-Industrie einer der größten Hebel einer nachhaltigeren Lebensweise ist. Ich denke da an veganen Fleischersatz und Lebensmittel,
      die mit fairen, ökologischen und wertebasierten Produktionsmethoden hergestellt werden. Gerade dieser Bereich wird in den nächsten Jahren noch weiter
      wachsen und interessiert mich deshalb als Investor. Daneben bin ich als Ex-Sportler natürlich sehr auf gesunde Ernährung gepolt und weiß, welch große
      Bedeutung dies für unsere Gesundheit und Leistung hat. Damit kann ich hoffentlich viele Menschen für eine gute Ernährung begeistern.
    </p>

    <p><strong>Wie fandest Du die Teilnahme am voilà! - Pitch in Frankfurt am Main am 31.08.2020?</strong></p>
    <p>
      Für uns war es nicht nur sehr spannend, die Startup pitches zu sehen, sondern auch, die zahlreichen Partner und Persönlichkeiten hinter Markant
      kennenzulernen. Wir sind nachhaltig beeindruckt von der Professionalität und der Reichweite der Markant Gruppe und freuen uns auf weiteren Austausch in
      der Zukunft.
    </p>

    <p><strong>Was hat dir am Pitch am besten gefallen und hast Du Tipps für die Start-ups?</strong></p>
    <p>
      Die Intensität des Pitches war sehr interessant mitzuerleben, einerseits die Vorträge der einzelnen Start-ups und anderseits die Fragen der jeweiligen
      Markant-Partner danach, die sehr gezielt waren. Hier wusste jeder sofort, welche Informationen relevant sind, um sich sofort ein Bild von den Startups zu
      machen.
    </p>

    <p><strong>Was findest du, müssen Gründerinnen und Gründer auf jeden Fall mitbringen?</strong></p>
    <p>
      Ganz wichtig ist mir Leidenschaft für ihr Thema - ob ein Gründer wirklich für seine Idee brennt und kämpft, das merkt man ja sofort. Dann sollte natürlich
      auch eine gute Portion Realismus und Know How dabei sein. Träume sind gut, aber die Due Diligence muss auch stimmen! Es gibt in vielen Branchen einen
      extrem harten Konkurrenzkampf - da sollte man sich von Anfang an warm anziehen.
    </p>

    <p><strong>Wie ist es als Nachfolger von Frank Thelen in der Höhle der Löwen zu sein?</strong></p>
    <p>
      Toll. Ich finde, die Show ist nicht nur unterhaltend, sondern für mich als Investor wirklich eine enorme Herausforderung. Schließlich muss man innerhalb
      von sehr kurzer Zeit sehr gewichtige Entscheidungen treffen und hat dafür manchmal nicht annähernd genug Informationen zur Hand. Da zählt oft die
      Erfahrung und das Bauchgefühl und das macht es so spannend.
    </p>

    <p><strong>Was glaubst du, worin besteht der Foodtrend der nächsten Jahre?</strong></p>
    <p>
      Ich denke, vegane Produkte werden künftig auch den Massenmarkt erobern, weil sich bei vielen ein neues Verständnis für die Folgen von Massentierhaltung
      und die damit verbundenen Emissionen breit gemacht hat. Meine Hoffnung ist, dass dieses Verständnis dazu führt, dass vegane Produkte aus ihrer Nische
      geholt werden und auch für die bisherigen Verweigerer attraktiver werden. Mit Bio hat das ja auch ganz gut geklappt.
    </p>

    <p><strong>Was sind Deine Ziele als Investor in den nächsten Jahren?</strong></p>
    <p>
      Also, natürlich wünsche ich mir, dass möglichst viele meiner Investments sehr erfolgreich werden. Daneben möchte ich mich neben der Mobilität - die ich ja
      schon viele Jahre in meinem Portfolio habe - auch in anderen nachhaltigen Trends breiter aufstellen. Auf meinem Greentech Festival gibt es immer so viele
      spannende Innovationen aus allen Ecken - es tut sich viel und es ist toll, dass ich als Investor dabei sein kann.
    </p>
  </div>
</div>
